module.exports = __webpack_public_path__ + "img/tmp1.a61aaf49.png";